<template>
  <div class="row">
    <div class="col-12">
      <div>          
        <h3 class="text-center">
         {{$t('anios_graph')}}
         </h3>
        </div>
      <div class="radio-select text-center">

        <div class="btn-group btn-group-toggle">
          <label class="btn btn-secondary active">
            <input type="radio" name="options" value="anio_aprob" id="option1"  v-model="fieldSelected" autocomplete="off" checked>{{$t('anios_graph_aprob')}}
          </label>
          <label class="btn btn-secondary">
           <input type="radio" name="options"  value="anio_informe" id="option2"  v-model="fieldSelected" autocomplete="off"> 
           {{$t('anios_graph_sup')}}
          </label>
        </div>
      </div>
    </div>
    <div class="col-12">
      <highcharts class="packedbubble" :options="graphOptions"></highcharts>
    </div>
    <div class="col-12">
      <div class="btn-graph d-none d-md-block text-center">
        <router-link class="btn btn-planes" :to="{ name: 'Planes' }">
          <span>{{$t('anios_graph_explo')}}</span>
        </router-link>
      </div>
    </div>
      

  </div>
</template>

<style lang="scss">

</style>

<script>

  import { Chart } from 'highcharts-vue'
  import Highcharts from "highcharts"
  import more from 'highcharts/highcharts-more'
  import streamgraph from 'highcharts/modules/streamgraph'
  import { map, filter, groupBy, uniq } from 'lodash'

  more(Highcharts)
  streamgraph(Highcharts)

  export default {
    name: 'aniosGraph',
    props: {
      dataset: Array
    },
    components: {
      highcharts: Chart
    },
    data() {
      return {
        fieldSelected: 'anio_aprob'
      }
    },
    computed: {
      graphOptions() {
        return {
          chart: {
              type: 'spline'
          },
          credits: {
            enabled: false
          },
          title: {
              text: ''
          },
          subtitle: {
              text: ''
          },
          legend: {
            enabled: true
          },
          xAxis: {
              categories: this.anios_aprob,
              crosshair: true
          },
          yAxis: {
              min: 0,
              title: {
                  text: 'PMF aprobados'
              }
          },
          tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                  '<td style="padding:0"><b>{point.y} PMF</b></td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
          },
          plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            },
            series: {
              ignoreNulls: 'fillSpace'
            }
          },
          series: this.n_data
        }
      },
      colors() {
        return {
          "Predio Privado": '#0f5106'
        }
      },
      anios_aprob() {
        return uniq(map(this.dataset, this.fieldSelected)).sort()
      },
      n_data() {
        return map(groupBy(this.dataset, 'modalidad'), (item, mod) =>  {
          return {
            name: this.$t(mod),
            color: this.colors[mod],
            data: filter(map(this.anios_aprob, (year) => {
              return {
                name: year, 
                y: filter(item, [this.fieldSelected, year]).length
              }
            }), item => item.name != 'ND')
          }
        })
      }
    }
  }
</script>